import { Contrast } from 'lucide-react';
import React, { ReactElement } from 'react';

import { AppSidebar } from 'src/components/app-sidebar';
import { Button } from 'src/components/ui/button';
import { Separator } from 'src/components/ui/separator';
import { SidebarProvider, SidebarTrigger } from 'src/components/ui/sidebar';
import { usePreferences } from 'src/hooks/usePreferences';
import { useToolbar } from 'src/hooks/useToolbar';
import { useTheme } from 'src/providers/ThemeProvider';

type BrandSidebarWithHeaderProps = {
  children: ReactElement[] | ReactElement;
  footer?: boolean;
  placeholder?: string;
  fullWidth?: boolean;
};

export function BrandSidebarWithHeader({
  children,
}: BrandSidebarWithHeaderProps): ReactElement {
  const { sidebar, setSidebar } = usePreferences();
  const { toolbarTitle } = useToolbar();
  const { theme, setTheme } = useTheme();

  return (
    <SidebarProvider open={sidebar} onOpenChange={setSidebar}>
      <AppSidebar />
      <div className='flex h-screen w-full flex-col overflow-hidden'>
        <div className='flex h-14 shrink-0 items-center gap-2 bg-layout px-5 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-16'>
          <div className='flex items-center gap-2 pr-2'>
            <SidebarTrigger className='size-7' />
          </div>
          <Separator orientation='vertical' className='h-3/5' />
          <span className='ml-2 text-nowrap font-medium text-layout-foreground-secondary'>
            {toolbarTitle}
          </span>
          <div className='flex w-full items-center justify-end'>
            <Button
              key={theme}
              variant='ghost'
              className='p-2 focus:outline-none focus:ring-0 focus:ring-offset-0'
              onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            >
              <Contrast className='size-5 text-layout-foreground' />
            </Button>
          </div>
        </div>
        <Separator />
        {children}
      </div>
    </SidebarProvider>
  );
}
